<template>
    <VoteSimulation :should-lose="true"></VoteSimulation>
</template>

<script>
import VoteSimulation from '@/components/VoteSimulation.vue';
export default { components: {VoteSimulation} };
</script>